import { createQueryKeys } from '@lukemorales/query-key-factory';

import { getEnums } from '../clients/coreData.api';

export const enums = createQueryKeys('enums', {
    list: {
        queryKey: null,
        queryFn: () => getEnums(),
    },
});
